export interface CustomerDetailApi {
  id: string;
  name: string;
  accountNumber: string;
  currency: string;
  outstanding: number;
  overdue: number;
  creditLimit: number;
  currencyCreditLimit: number;
  dso: number | null;
  risk: string;
  lastPayment?: string;
  contact: string;
  phone: string;
  address: string;
  primaryAddressLine?: string;
  primaryAddressTown?: string;
  primaryAddressCounty?: string;
  primaryAddressPostCode?: string;
  primaryAddressCountry?: string;
  statementAddressLine?: string;
  statementAddressTown?: string;
  statementAddressCounty?: string;
  statementAddressPostCode?: string;
  statementAddressCountry?: string;
  paymentTerms: string;
  collectionStrategyId?: string;
  creditControllerId?: string;
  creditControllerName?: string;
  creditControllerEmail?: string;
  accountManagerId?: string;
  primaryContactFirstName?: string;
  primaryContactSurname?: string;
  riskLevelId?: number;
  riskLevelName?: string;
  onStop?: boolean;
  status?: string;
  userSortKey1?: string;
  userSortKey2?: string;
  userSortKey3?: string;
  userSortKey4?: string;
  userSortKey1Label?: string;
  userSortKey2Label?: string;
  userSortKey3Label?: string;
  userSortKey4Label?: string;
  dueDays?: number;
  dueDaysType?: string;
  groupDso?: number;
  isAnyCurrency?: boolean;
  transactionCurrencies?: string[];
}

export interface CustomerAgeingBandApi {
  sequence: number;
  label: string;
  bandLabel: string;
  startDays: number;
  endDays: number | null;
  totalOutstanding: number;
  transactionCount: number;
}

export interface CustomerAgeingApi {
  bands: CustomerAgeingBandApi[];
  totalOutstanding: number;
  totalOverdue: number;
}

export interface InvoiceApi {
  id: string;
  invoiceNumber: string;
  date: string;
  dueDate: string;
  amount: number;
  status: 'overdue' | 'outstanding' | 'paid';
  daysOverdue: number;
}

export interface OutstandingInvoicesApiResponse {
  invoices: InvoiceApi[];
  totalOutstanding: number;
  totalOverdue: number;
}

export interface PaymentAllocationApi {
  invoiceId: string;
  invoiceNumber: string;
  invoiceDate: string;
  amount: number;
}

export interface PaymentApi {
  id: string;
  paymentNumber: string;
  date: string;
  amount: number;
  method: string;
  reference: string;
  allocations: PaymentAllocationApi[];
}

export interface PaymentHistoryApiResponse {
  payments: PaymentApi[];
  totalPayments: number;
  lastPaymentDate?: string;
}

export interface CommunicationApi {
  id: string;
  customerId: string;
  customerName: string;
  contactName: string;
  type: 'email' | 'phone' | 'chat' | 'meeting' | 'sms' | 'video' | 'note' | 'portal';
  subject: string;
  content: string;
  status: 'sent' | 'delivered' | 'read' | 'replied' | 'completed' | 'failed';
  direction: 'inbound' | 'outbound';
  source?: string;
  createdAt: string;
  createdBy: string;
  metadata?: {
    emailTo?: string;
    emailFrom?: string;
    duration?: string;
    attendees?: string[];
  };
}

export interface CommunicationsApiResponse {
  communications: CommunicationApi[];
  totalCount: number;
}

export interface ContactApi {
  id: string;
  title?: string;
  firstName: string;
  surname: string;
  email: string;
  phone: string;
  mobile?: string;
  preferredContactMethod?: string;
  jobTitle?: string;
  company: string;
  customerId: string;
  address?: string;
  notes: string;
  createdAt: string;
  lastContact: string | null;
  isPrimary: boolean;
}

export interface ContactsApiResponse {
  contacts: ContactApi[];
  totalCount: number;
}

export interface CustomerAddressApi {
  id: number;
  customerId: number;
  externalId?: string;
  accountCode?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  fax?: string;
  addressLine?: string;
  town?: string;
  county?: string;
  postCode?: string;
  country?: string;
  countryCode?: string;
  isInvoice: boolean;
  isStatement: boolean;
  isDelivery: boolean;
  isDeliveryDefault?: boolean;
  isPrimary: boolean;
  contactId?: number;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerAddressesApiResponse {
  addresses: CustomerAddressApi[];
  totalCount: number;
}

export interface StubResponse {
  message: string;
}

export function isStubResponse(response: unknown): response is StubResponse {
  return (
    !!response &&
    typeof response === 'object' &&
    'message' in response &&
    !('data' in response) &&
    !('invoices' in response) &&
    !('payments' in response) &&
    !('communications' in response) &&
    !('contacts' in response) &&
    !('addresses' in response) &&
    !('bands' in response)
  );
}
